import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

// Live countdown to the end of the current local day ("Deal of the Day").
// Self-resets each midnight so the deal always shows time remaining.
function msToEndOfDay() {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return end.getTime() - now.getTime();
}

function fmt(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = String(Math.floor(total / 3600)).padStart(2, "0");
  const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
}

export default function DealCountdown({ compact = false, className = "", testid }) {
  const [ms, setMs] = useState(msToEndOfDay());

  useEffect(() => {
    const t = setInterval(() => setMs(msToEndOfDay()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 font-mono-caption text-orange-400 ${compact ? "text-[10px]" : "text-xs"} ${className}`}
    >
      <Timer className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} />
      <span className="tabular-nums">Ends in {fmt(ms)}</span>
    </span>
  );
}
